/**
 * Browser storage that belongs to one account. Keys are suffixed with the uid so a
 * different account on the same browser never reads another account's data.
 */

export const DESIGN_DRAFT_KEY = 'customAIDesigner_autoSave'
export const FAVORITES_KEY = 'style_ai_favorites'
export const PREFERENCES_KEY = 'style_ai_preferences'

const GUEST_SCOPE = 'guest'

// Written before drafts were scoped, so their owner is unknown. Never read them.
const LEGACY_LOCAL_KEYS = [DESIGN_DRAFT_KEY, FAVORITES_KEY, PREFERENCES_KEY, 'style_ai_studio_draft']

export function scopedKey(base, uid) {
  return `${base}:${uid || GUEST_SCOPE}`
}

export function readScoped(base, uid) {
  try {
    const raw = localStorage.getItem(scopedKey(base, uid))
    return raw ? JSON.parse(raw) : null
  } catch {
    removeScoped(base, uid)
    return null
  }
}

export function writeScoped(base, uid, value) {
  try {
    localStorage.setItem(scopedKey(base, uid), JSON.stringify(value))
  } catch (_) {}
}

export function removeScoped(base, uid) {
  try {
    localStorage.removeItem(scopedKey(base, uid))
  } catch (_) {}
}

export function purgeLegacyUnscopedData() {
  LEGACY_LOCAL_KEYS.forEach((key) => {
    try {
      localStorage.removeItem(key)
    } catch (_) {}
  })
}
